import './Home.css';
import '../../../Styles.css';
import React, {useContext, useMemo} from 'react';
import {ProviderProfileContext} from "../../../../ProviderProfileProvider";
import {space} from "../../../../provider_api";
import {Link} from "react-router-dom";
import {CompletionChecklist} from "./CompletionChecklist";
import {Dashboard} from "./Dashboard";
import {ProviderRejected} from "./ProviderRejected";
import {profileIsReadyToPublish} from "../../WebsiteValidator";
import ProviderApprovalState = space.kenko.proto.ProviderApprovalState;

// There are two main states here. 
// 
// 1. There is no live profile. In this case we show the onboarding checkout.
// 2. There is a live profile. In this case we show the dashboard.
export const Home = () => {

  const {business} = useContext(ProviderProfileContext);

  if (!business?.published) {
    return <CompletionChecklist/>
  }

  return <Dashboard/>;
}
